module.exports = __webpack_public_path__ + "static/media/header.eaace058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/header.jpg
// module id = 497
// module chunks = 0